import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { Spin } from "antd";
import SlayerMasterSection from "./SlayerMasterSection.js";
import SlayerTaskSection from "./SlayerTaskSection.js";

const SlayerApp = () => {
  const [dbLastUpdated, setDbLastUpdated] = useState(null);
  const [slayerMasters, setSlayerMasters] = useState([]);
  const [selectedMasterName, setSelectedMasterName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [slayerTasks, setSlayerTasks] = useState([]);

  useEffect(() => {
    axios
      .get("/data/slayer-masters.json")
      .then((response) => {
        const { slayer_masters, db_last_updated } = response.data;
        setSlayerMasters(slayer_masters);
        setDbLastUpdated(db_last_updated);
      })
      .catch((error) =>
        // TODO: add error handling for this...
        console.error("Error fetching data:", error)
      );
  }, []);

  useEffect(() => {
    if (!selectedMasterName) return;

    setSlayerTasks([]);
    const selectedMasterObj = slayerMasters.find(
      (master) => master.master_name === selectedMasterName
    );
    if (!selectedMasterObj) return;

    fetchSlayerTasks(selectedMasterObj);
  }, [selectedMasterName, slayerMasters]);

  const fetchSlayerTasks = async (selectedMasterObj) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/data/slayer-tasks-${selectedMasterObj.master_id}.json`
      );
      setSlayerTasks(
        response.data.toSorted((a, b) => b.task_weight - a.task_weight)
      );
    } catch (err) {
      // TODO: add error handling for this...
      // setError("Error fetching slayer tasks");
      console.error("Error fetching slayer tasks:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSetSlayerMasterName = (name) => {
    if (name !== selectedMasterName) {
      setSelectedMasterName(name);
    }
  };

  return (
    <>
      <Banner>
        Data last updated on:{" "}
        <strong>
          {new Date(dbLastUpdated).toLocaleString(undefined, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </strong>
      </Banner>
      <SlayerAppContainer>
        {slayerMasters && (
          <SlayerMasterSection
            slayerMasters={slayerMasters}
            setSlayerMasterName={handleSetSlayerMasterName}
          />
        )}
        {loading && <Spin size={"large"} style={{ marginTop: "20px" }} />}
        {selectedMasterName && !!Object.keys(slayerTasks).length && (
          <SlayerTaskSection
            slayerMasterId={
              slayerMasters.find(
                (master) => master.master_name === selectedMasterName
              ).master_id
            }
            slayerTasks={slayerTasks}
          />
        )}
      </SlayerAppContainer>
    </>
  );
};

export default SlayerApp;

const Banner = styled.div`
  background-color: #282828;
  color: #ffff00;
  text-align: center;
  font-size: 14px;
  font-family: "Chakra Petch", sans-serif;
  width: 100%;
  border-radius: 0 0 8px 8px;
`;

const SlayerAppContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 50px 0px;
`;
